<template>
<div>
  <div v-show="!title" class="fixed h-screen w-full bg-white bg-opacity-90 z-50 flex justify-center items-center"> 
    <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-theme-sky"></div>
  </div>
  <div class="flex-grow">
    <div class="bg-theme-light">
      <div class="section container px-6 py-16 mx-auto">
          <div class="items-center lg:flex">
              <div class="w-full flex flex-col jusctify-center text-center">
                  <h1 class="text-2xl text-gray-600 dark:text-white leading-9">{{pretitle}}<br> <span class="text-theme-blue text-5xl font-bold">{{title}}</span> </h1>

                  <p class="mt-4 text-gray-600 dark:text-gray-400">{{subtitle}}</p>

                  <div class="flex flex-col mt-8 mx-auto lg:flex-row w-11/12 md:w-2/3 justify-center">
                      <input v-model="filterTitle" id="filterTitle" type="text" 
                             class="mt-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg 
                                    dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 
                                    focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring lg:mx-3" 
                                    placeholder="Título"
                              @keyup.enter="getBooks">

<!--                       <input id="select" type="text" v-model="filterAutor"
                             class="mt-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg 
                                    dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 
                                    focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring lg:mx-3" 
                                    placeholder="Autor" list="authors"
                              @keyup.enter="getBooks">
                              <datalist id="authors">
                                <option v-for="author in authors" 
                                        :key="author.id">{{author.fullname}}</option>
                              </datalist> -->

                            <input id="select" type="text" v-model="filterAutor"
                             class="mt-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg 
                                    dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 
                                    focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring lg:mx-3" 
                                    placeholder="Autor"
                              @keyup.enter="getBooks">


                      <select v-model="filterLibrary" name="" id="" 
                              class="mt-2 px-4 py-2 bg-white border border-gray-300 rounded-lg 
                                     dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 
                                     focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring lg:mx-3"  
                              :class="{'text-gray-400': this.filterLibrary == '0',
                                       'text-gray-700': this.filterLibrary != '0'}">
                                                                
                        <option value="0" disabled>Selecciona una Biblioteca</option>
                        <option value="" >Todas las bibliotecas</option>
                        <option v-for="lib in libraries" :key="lib.id" :value="lib.id">{{lib.name}}</option>
                      </select>                                                                                     
                      
                      <button @click.prevent="getBooks" class=" mt-2 h-12 w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg lg:w-auto lg:mx-4 hover:bg-indigo-400 focus:outline-none focus:bg-indigo-400 ">
                          <span class="font-semibold">Buscar</span>    
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                      </button>
                  </div>

              </div>
    
          </div>
      </div>
    </div> 
    <div class="section container px-6 py-16 mx-auto">      
      <div class="">
        <div v-if="this.filter.length > 0" class="w-full" @click="clearFilter"><button class="ml-auto flex items-center justify-center rounded-lg border border-red-400 text-red-400 py-1 px-2 text-sm
                            hover:bg-red-400 hover:text-white">
          <Icons name="trash" class="w-4 mr-2"/><span class="tracking-wider">LIMPIAR FILTRO</span></button></div>
        
        <div v-show="!books" class="flex justify-center items-center"> 
          <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-theme-sky"></div>
        </div>
        
        <div v-show="books.total == 0" class="flex justify-center items-center"> 
          <div>No se encontraron resultados</div>
        </div>

        <div v-for="book in books.data" :key="book.id" class="bg-theme-fa my-5 rounded-lg py-3 px-5 shadow-md">
          
          <div class="title h-1/2 text-lg md:text-2xl font-bold">{{book.title}}</div>
          <div class="autor text-theme-blue capitalize">{{book.lastname.toLowerCase()}}, {{book.name.toLowerCase()}}</div>
          <div class="flex justify-between mt-3 flex-col md:flex-row md:items-center">
            <div class="editorial text-sm text-gray-600">{{book.editorial}} - {{book.city}} - {{book.year}}</div>
            
            <router-link :to="{name:'BiblioDetail', params: {id:book.library[0].id}}">
                <div class="biblioteca font-semibold hover:text-theme-sky mt-2 text-base ">{{book.library[0].name}}</div>
            </router-link>
          </div>
        </div>
      
      </div>

      <div v-show="books" class="flex justify-between items-center">
        <div v-if="books.total > 0">
          Resultados encontrados: {{this.books.total}}
        </div>
        <div class="flex justify-end">
          <div v-if="this.prevpage" @click="getBooksPaginate(this.prevpage)" class="cursor-pointer bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center mr-4 hover:bg-theme-blue">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            ATRAS</div>
          <div v-if="this.nextpage" @click="getBooksPaginate(this.nextpage)" class="cursor-pointer bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center hover:bg-theme-blue">
            SIGUIENTE
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </div>

  </div> 
</div>

</template>

<script>


import Icons from '@/components/Icons.vue'  

export default {
  name: "Catalogo",   
  props:['filterHome'] , 
  components: {
    Icons
  },
  setup() {
      const img_banner = require('@/assets/images/home/banner1.svg')
      return {img_banner}
  },
  data(){
      return{
        books:"",
        filterTitle: "",
        filterAutor: "",
        filterLibrary:"0",
        filter: "",
        nextpage:"",
        prevpage:"",
        libraries:"",
        filterHome: this.$props.filterHome,
        title:"",
        pretitle:"",
        subtitle:"",
        filterSelectAutores:"",
        authors:""

      }
  },
  methods: {
    async getBooks(){
      
      this.books = ""
      let filter = ""
      if(this.filterAutor){
        filter += `&autor=${this.filterAutor}`
      }
      if(this.filterTitle){
        filter += `&title=${this.filterTitle}`
      }

      if(this.filterLibrary && this.filterLibrary != 0){
        filter += `&library=${this.filterLibrary}`
      }

      if(this.filterHome){
        filter = `&filterHome=${this.filterHome}`
        this.filterHome = false
      }

      this.filter= filter

      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/books?${filter}`;
      const response = await fetch(get,{method: 'GET'})
      this.books = await response.json()
      console.log(this.books.total)
      this.nextpage = this.books.next_page_url
      this.prevpage = this.books.prev_page_url

    },

    async getBooksPaginate(link){

      // var get = `${link}${this.filter}`;
      var get = `${link}`;
      const response = await fetch(get,{method: 'GET'})

      this.books = await response.json()
      this.nextpage = this.books.next_page_url
      this.prevpage = this.books.prev_page_url

    },

    async getLibraries(){
        var get = `${process.env.VUE_APP_URL_CULTURAPP}api/libraries`;
        const response = await fetch(get,{method: 'GET'})
        this.libraries = await response.json()
    },
    
    clearFilter(){

        this.filterTitle =  ""
        this.filterAutor =  ""
        this.filterEditorial =  ""
        this.filterLibrary = "0"
        this.filter =  ""
        this.filterHome = false
        
        this.getBooks()

    },

    async getContent(view){

      var filter = `?view=${view}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
      const response = await fetch(get,{method: 'GET'})
      const contents = await response.json()

      this.title = contents.filter(obj => obj.section == 'header' && obj.element == 'title')[0].content
      this.pretitle = contents.filter(obj => obj.section == 'header' && obj.element == 'pretitle')[0].content
      this.subtitle = contents.filter(obj => obj.section == 'header' && obj.element == 'subtitle')[0].content
    },    

    async getAuthors(){

        var get = `${process.env.VUE_APP_URL_CULTURAPP}api/books/authors`;
        const response = await fetch(get,{method: 'GET'})
        this.authors = await response.json()
    }

  },
  created(){
    this.getContent('catalogo')
    this.getLibraries()
    this.getBooks()
    this.getAuthors()
  },
  mounted () {
    window.scrollTo(0, 0)
  }, 
};
</script>
